import React, { Component } from "react"
import cloneDeep from "lodash/cloneDeep"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import Widget from "../layout/widget/Widget"
import DrilldownColumnChart from "../charts/generic/DrilldownColumnChart"
import CompletionGaugeChart from "../charts/generic/CompletionGaugeChart"
import { CHARTS } from "../../constants"
import { createItemNameShape } from "../../utils/widget-utils"
import DrilldownShape from "../../state/shapes/DrilldownShapes/DrilldownShape"

const TwoColumnChartClass = "col-md-8 col-sm-12"
const ThreeColumnChartClass = "col-md-12 col-sm-12"

class Completion extends Component {
  constructor(props) {
    super(props)

    this.state = {
      chartColumnWidth: TwoColumnChartClass,
      showGauge: true,
      allowUpdate: true,
      chartDrilldownLevel: 0
    }
  }

  onDrillDown = (event, chart) => {
    if (this.state.chartDrilldownLevel === 0) {
      this.setState(
        {
          showGauge: false,
          chartColumnWidth: ThreeColumnChartClass,
          allowUpdate: false,
          chartDrilldownLevel: this.state.chartDrilldownLevel + 1
        },
        () => {
          // After hiding section resize chart
          this.resizeDrilldownChart(chart)
          this.setChartTitle(chart, this.state.chartDrilldownLevel)
        }
      )
    } else {
      this.setChartTitle(chart, this.state.chartDrilldownLevel + 1)
      this.setState({ chartDrilldownLevel: this.state.chartDrilldownLevel + 1 })
    }
  }

  onDrillUp = (event, chart) => {
    // Look at level number to see if this is the top series
    if (event.seriesOptions._levelNumber === 0) {
      this.setState({
        chartColumnWidth: TwoColumnChartClass,
        showGauge: true,
        // Allow update so control is re-rendered
        // This will take us back to first drilldown level without introducing a bug
        // Bug was, drill down, then up, then back down and some columns would be wrong width or not displayed
        allowUpdate: true,
        // Set drill back to 0
        chartDrilldownLevel: 0
      })
    } else {
      this.setChartTitle(chart, this.state.chartDrilldownLevel - 1)
      this.setState({ chartDrilldownLevel: this.state.chartDrilldownLevel - 1 })
    }
  }

  setChartTitle = (chart, drilldownLevel) => {
    chart.xAxis[0].setTitle({
      text: this.props.t(`LocationTierLabel_Lvl_${drilldownLevel - 1}`)
    })
  }

  resizeDrilldownChart = chart => {
    chart.setSize(undefined, chart.height, false)
  }

  translateStageNames = data => {
    const output = cloneDeep(data)
    if (
      output.rootSeries &&
      output.rootSeries[0] &&
      output.rootSeries[0].drilldownObjects &&
      output.rootSeries[0].drilldownObjects.length > 0
    ) {
      const innerArray = []

      output.rootSeries[0].drilldownObjects.forEach(x => {
        innerArray.push({ ...x, name: this.props.t(x.name) })
      })

      output.rootSeries[0].drilldownObjects = innerArray
    }

    return output
  }

  render() {
    const { t, exportEndpoint, appliedFilters, subtitleKey } = this.props

    const data = this.translateStageNames(this.props.data)

    const gaugeData = createItemNameShape(
      "Reporting.Completion",
      Math.round(data.totalCompletionPercentage)
    )

    const stopsValues = [
      [0.15, CHARTS.trafficLightColours.red], // red
      [0.4, CHARTS.trafficLightColours.amber], // yellow
      [0.7, CHARTS.trafficLightColours.green] // green
    ]

    const titleKey = "Widgets.Completion.Title"

    return (
      <Widget
        columns={3}
        helpKey="Widgets.ReviewCompletion.Help"
        exportEndpoint={exportEndpoint}
        appliedFilters={appliedFilters}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      >
        <div
          className={this.state.chartColumnWidth}
          ref={c => {
            this.drilldownChartContainerRef = c
          }}
        >
          <DrilldownColumnChart
            data={data}
            yAxisTitle="Common.Percentage"
            yAxisMaxValue={100}
            xAxisTitle="Common.Stage"
            onDrillUp={this.onDrillUp}
            onDrillDown={this.onDrillDown}
            allowUpdate={this.state.allowUpdate}
            scrollbarEnabled
            chartDrilldownLevel={this.state.chartDrilldownLevel}
            titleKey={titleKey}
            subtitleKey={subtitleKey}
          />
        </div>
        {this.state.showGauge && (
          <div className="col-md-4 col-sm-12 text-center">
            <CompletionGaugeChart
              data={gaugeData}
              stopsValues={stopsValues}
              titleKey={titleKey}
              labelKey="Common.Overall"
              subtitleKey={subtitleKey}
            />
            {t("Widgets.Completion.TotalSent")}: {data.totalReviewsSent}
          </div>
        )}
      </Widget>
    )
  }
}

Completion.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape(DrilldownShape).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string
}

export default translate()(Completion)



// WEBPACK FOOTER //
// ./src/components/widgets/Completion.jsx